import { contactBttnClick } from '../../../state/user-actions';
import { cl_sidebarBttn } from '../../constants/html-classnames';
import { id_bttnContactInSidebar } from '../../constants/html-ids';
import { transl } from '../../localisation/translate';
import { ClickBttn } from '../buttons/click-button';

export const ContactBttn = ({
  status,
  dict,
}: {
  status: string;
  dict: Default.Str2StrMap;
}) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnContactInSidebar}
    iconClass={status}
    iconType={<span>{transl('#sidebar|contact', dict)}</span>}
    onBttnClick={contactBttnClick}
  />
);
